import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useNavigate } from 'react-router-dom';

function Navbar() {
    
    const [show, handleShow] = useState(false);

    const navigate = useNavigate();

    function transitionNavbar () {
        if (window.scrollY > 100) {
            handleShow(true);
        } else {
            handleShow(false);
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", transitionNavbar);
        return () => window.removeEventListener("scroll", transitionNavbar);
    }, []);

  return (
        <div className={`navbar ${show && "navbar__black"}`}>
            <div className="navbar__contents">
                <img onClick={() => navigate('/')} src="https://assets.stickpng.com/images/580b57fcd9996e24bc43c529.png" alt="Netflix Logo" className="netflix__logo" />
                <img onClick={() => navigate('/profile')} src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png" alt="Avatar" className="avatar__logo" />
            </div>
        </div>
  )
}

export default Navbar